import actions from './actions';
import mutations from './mutations';

// state initial values
const state = {
  orderList: [],
  currentOrder: null
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
